var _path, _circle, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 61,
    viewBox: "0 0 57 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1953 6.98828L8.18359 29H35.5V55.25C35.5 55.9792 35.3633 56.6628 35.0898 57.3008C34.8164 57.9388 34.4427 58.4948 33.9688 58.9688C33.4948 59.4427 32.9388 59.8164 32.3008 60.0898C31.6628 60.3633 30.9792 60.5 30.25 60.5H9.25C8.52083 60.5 7.83724 60.3633 7.19922 60.0898C6.5612 59.8164 6.00521 59.4427 5.53125 58.9688C5.05729 58.4948 4.68359 57.9388 4.41016 57.3008C4.13672 56.6628 4 55.9792 4 55.25V33.1836L2.98828 34.1953L0.5 31.7344L7.9375 24.2969L5.44922 21.8359C5.12109 21.5078 4.875 21.1341 4.71094 20.7148C4.54688 20.2956 4.45573 19.8398 4.4375 19.3477C4.4375 18.418 4.77474 17.5977 5.44922 16.8867L12.8594 9.44922C13.1875 9.12109 13.5612 8.875 13.9805 8.71094C14.3997 8.54688 14.8555 8.45573 15.3477 8.4375C15.8216 8.4375 16.2682 8.51953 16.6875 8.68359C17.1068 8.84766 17.4896 9.10286 17.8359 9.44922L20.2969 11.9375L27.7344 4.5L30.1953 6.98828ZM32 55.25V32.5H7.5V55.25C7.5 55.724 7.67318 56.1341 8.01953 56.4805C8.36589 56.8268 8.77604 57 9.25 57H30.25C30.724 57 31.1341 56.8268 31.4805 56.4805C31.8268 56.1341 32 55.724 32 55.25ZM15.3477 11.9375L7.9375 19.3477L10.3984 21.8359L17.8359 14.3984L15.3477 11.9375ZM28.5 36V53.5H25V36H28.5ZM21.5 36V53.5H18V36H21.5ZM14.5 36V53.5H11V36H14.5Z",
    fill: "#495057"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.1514,
    cy: 14.8481,
    r: 2.25,
    transform: "rotate(45 42.1514 14.8481)",
    stroke: "#7663EB",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4398 24.9241L39.5005 25.9848C41.8436 23.6416 41.8436 19.8426 39.5005 17.4995C37.1573 15.1563 33.3583 15.1563 31.0152 17.4995L32.0758 18.5601C33.8332 16.8028 36.6824 16.8028 38.4398 18.5601C40.1972 20.3175 40.1972 23.1667 38.4398 24.9241Z",
    fill: "#7663EB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40.5605,
    y: 3.71105,
    width: 18,
    height: 20.25,
    rx: 5.25,
    transform: "rotate(45 40.5605 3.71105)",
    stroke: "#495057",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteAccount);
export default __webpack_public_path__ + "static/media/delete-account.4560e672e74a1a580b56aceabb910745.svg";
export { ForwardRef as ReactComponent };